__turbopack_context__.v({
  "socialbar": "Socialbar-module__C_3A_q__socialbar",
  "socialbarItem": "Socialbar-module__C_3A_q__socialbarItem",
  "socialbarLink": "Socialbar-module__C_3A_q__socialbarLink",
});
